module.exports = "/images/vendor/flag-icon-css/flags/4x3/id.svg?17b996767ee0373a262c32a16248a3b6";